export function setBirthdays(state, birthdays) {
  state.birthdays = birthdays;
}

export function birthdaysError(state, payload) {
  state.error = true
  state.errorMessage = payload
  state.birthdays = []
}